import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/lib/api-client'
import { CACHE_CONFIG } from '~/lib/cache-config'

export async function listPublicCategories() {
  const res = await apiClient.categories.$get({ query: {} })
  if (!res.ok) {
    console.error("Failed to fetch categories", await res.text())
    return []
  }
  const json = await res.json()
  return json.data as any
}

export function publicCategoriesQueryOptions() {
  return queryOptions({
    queryKey: ['public', 'categories'],
    queryFn: () => listPublicCategories(),
    staleTime: CACHE_CONFIG.reference.staleTime,
    gcTime: CACHE_CONFIG.reference.gcTime,
  })
}

export function usePublicCategories() {
  return useSuspenseQuery(publicCategoriesQueryOptions())
}
